import { defineComponent as _defineComponent } from 'vue';
import CompanyLayout from '@/Layouts/Company.vue';
import { Head, usePage } from '@inertiajs/inertia-vue3';
import CompanyForm from '@/Pages/Company/Form.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    setup(__props, { expose }) {
        expose();
        const page = usePage();
        const company = page.props.value.company;
        const title = "Dettagli Azienda";
        const __returned__ = { page, company, title, CompanyLayout, CompanyForm };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
